import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[agprOverlayTarget]',
    exportAs: 'agprOverlayTarget',
    providers: [],
    standalone: false
})
export class OverlayTargetDirective {
    constructor(public tpl: TemplateRef<any>){}
}
